import {graphql, useFragment} from 'react-relay'

import type {RunStatusFragment$key} from './__generated__/RunStatusFragment.graphql'
import type {BaseProps} from './RunStatus'
import RunStatus from './RunStatus'

const fragment = graphql`
  fragment RunStatusFragment on Build {
    rawId
    status
    state
    parallelized
    canceledInfo {
      timestamp
    }
    failedToStart
    statusText
    waitReason
    startEstimate
  }
`

type Props = BaseProps & {
  runKey: RunStatusFragment$key | null
}

export function RunStatusRelay({runKey, ...props}: Props) {
  const run = useFragment(fragment, runKey)
  return <RunStatus {...props} {...run} id={run?.rawId} />
}
